import queryString from 'query-string';

import {
  IBrandsOptions,
  IDepartmentsOptions,
  ISearchOptions,
} from 'api/catalog/models';

export class ComputedRoute {
  public static getHomeRoute = () => {
    return '/';
  };

  public static getSearchRoute = (options: ISearchOptions) => {
    // console.log('options: ', options);
    return `/search?${queryString.stringify(options, {
      arrayFormat: 'comma',
    })}`;
  };

  public static getBrandsRoute = (options: IBrandsOptions) => {
    // console.log('options: ', options);
    return `/brands?${queryString.stringify(options, {
      arrayFormat: 'comma',
    })}`;
  };

  public static getCategoriesRoute = (options: IDepartmentsOptions) => {
    // console.log('options: ', options);
    return `/categories?${queryString.stringify(options, {
      arrayFormat: 'comma',
    })}`;
  };

  public static getProductDetailsRoute = (itemNumber: string) => {
    // console.log('itemNumber: ', itemNumber);
    return `/products/${itemNumber}`;
  };
}
